<template>
    <q-card flat>
        <q-card-section>
            <div class="text-h5 text-bold text-uppercase">Species</div>
        </q-card-section>
        <q-card-section class="q-pt-none q-pl-sm" v-if="processedData[version] && processedData[version]['coastalOffshore'] && processedData[version]['coastalOffshore']['offshore']">
            <q-list bordered class="rounded-borders bottom-border" role="list">
                <q-expansion-item v-model="summary" group="sp" header-class="bg-grey-5" expand-separator dense  @click="goTo('summary', 'SPECIES_SUMMARY')" class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                            Summary 
                        </q-item-section>
                        <q-item-section v-if="summary">
                            <div class="row justify-end">
                                <div class="q-mt-xs q-mb-xs q-pl-sm q-pr-sm shadow-1 rounded"  @click.stop="print('speciesSummaryPane', version, 'Species Summary')" v-if="!printing" aria-label="Print summary"><q-icon name="print" size="xs"></q-icon></div>
                                <q-spinner v-else />
                            </div>
                        </q-item-section>
                    </template>
                    <router-view v-if="summary" :data="rawData" :version="version" :ecoregion="rawData['majEcoregion'].toString()"></router-view>
                </q-expansion-item>
   
                <q-expansion-item  v-model="fish" group="sp"  expand-separator dense  @click="goTo('fish', 'FISH_HIGHBIO_ALL')" class="exp-panel" role="listitem"  >
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Fish 
                        </q-item-section>
                    </template>
                    <router-view v-if="fish" :data="rawData" :version="version" :ecoregion="rawData['majEcoregion'].toString()"></router-view>
                </q-expansion-item>
                <q-expansion-item  v-model="mammals" group="sp"  expand-separator dense   @click="goTo('mammals', 'MAMMAL_YEAR')"  class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Mammals
                        </q-item-section>
                    </template>
                    <router-view v-if="mammals" :data="rawData" :version="version" :ecoregion="rawData['majEcoregion'].toString()"></router-view>
                </q-expansion-item>
                <q-expansion-item  v-model="birds" group="sp"  expand-separator dense  @click="goTo('birds', 'BIRD_YEAR')"  class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Offshore Birds
                        </q-item-section>
                    </template>
                    <router-view v-if="birds" :data="rawData" :version="version" :ecoregion="rawData['majEcoregion'].toString()"></router-view>
                </q-expansion-item>
                <q-expansion-item v-model="coastalbirds" group="sp"  expand-separator dense  @click="goTo('coastalbirds', 'COASTAL_BIRD_YEAR')" class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Coastal Birds
                        </q-item-section>
                    </template>
                    <router-view v-if="coastalbirds" :data="rawData" :version="version" :ecoregion="rawData[version['majEcoregion']]"></router-view>                   
                </q-expansion-item>
                <!--  <q-expansion-item v-model="corals" group="sp"  expand-separator dense  class="exp-panel" @click="goTo('corals', 'CORALS')" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Corals
                        </q-item-section>
                    </template>
                    <router-view v-if="corals" :data="rawData" :version="version" :ecoregion="rawData['majEcoregion'].toString()"></router-view>
                </q-expansion-item> -->
                <q-expansion-item  v-model="turtles" group="sp" @click="goTo('turtles', 'TURTLE_YEAR')" expand-separator dense class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Turtles
                        </q-item-section>
                    </template>
                    <router-view v-if="turtles" :data="rawData" :version="version" :ecoregion="rawData['majEcoregion'].toString()"></router-view>
                </q-expansion-item>
                <q-expansion-item
                    group="sp"
                    dense
                    class="exp-panel"
                    expand-separator
                    label="Data Considerations"
                    @click="goTo('data', 'GRID')"
                    v-model="dataqual"
                    header-class="bg-grey-5" 
                    role="listitem"
                >
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Data Considerations
                        </q-item-section>
                        <q-item-section v-if="dataqual">
                            <div class="row justify-end">
                                <div class="q-mt-xs q-mb-xs q-pl-sm q-pr-sm shadow-1 rounded"  @click.stop="print('speciesDataConsiderationsPane', version, 'Species Data Considerations')" v-if="!printing" aria-label="Print summary"><q-icon name="print" size="xs"></q-icon></div>
                                <q-spinner v-else />
                            </div>
                        </q-item-section>
                    </template>
                    <router-view v-if="dataqual" :data="rawData" :version="version"></router-view>
                </q-expansion-item>
            </q-list>
        </q-card-section>
        <q-card-section v-else>
            <div class="text-center text-h5">The AOI does not include any offshore areas.</div>
        </q-card-section>
    </q-card>
</template>
<script setup>
import { toRefs, computed, ref, onMounted, watch } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const {  print, printing, ecos, loadDataByID, processedData} = useMapItems()
const { logGAevent } = useHelpers();

const props = defineProps({
    rawData: { type: Object, default: null },
    version: {type: Number}
})

const { rawData, version} = toRefs(props)
const ecoregionLabel = (ecoregion) => {
    let text = "Ecoregion Summary: " + ecos[ecoregion]
    return text
}

const summary = ref(false)
const fish = ref(false)
const mammals = ref(false)
const birds = ref(false)
const coastalbirds = ref(false)
const corals = ref(false)
const turtles = ref(false)
const ecoregion1 = ref(false)
const ecoregion2 = ref(false)
const dataqual = ref(false)
const panelRefs = {
    summary,
    fish,
    mammals,
    birds,
    coastalbirds,
    corals,
    turtles,
    dataqual,
    ecoregion1,
    ecoregion2
}
const setExpansionPanel = (refName, value) =>{
  if (panelRefs[refName]) {
    panelRefs[refName].value = value;
  }
}

const goTo = (pane, layerID=null) =>{
    // console.log(pane)
    // console.log(layerID)
    logGAevent("species_pane", pane, "")
    if (layerID){
        loadDataByID(layerID, version)
    }
    router.push({
        path: `/results${version.value}/species/${pane}`
    })
}

const setPanels = (path) =>{
    // console.log(path)
    if (path.includes('species/summary')){
        setExpansionPanel('summary', true)
    }
    if (path.includes('species/fish')){
        setExpansionPanel('fish', true)
    }
    if (path.includes('species/mammals')){
        setExpansionPanel('mammals', true)
    }
    if (path.includes('species/birds')){
        setExpansionPanel('birds', true)
    }
    if (path.includes('species/corals')){
        setExpansionPanel('corals', true)
    }
    if (path.includes('species/turtles')){
        setExpansionPanel('turtles', true)
    }
    if (path.includes('species/data')){
        setExpansionPanel('dataqual', true)
    }
    if (path.includes('species/ecoregion1')){
        setExpansionPanel('ecoregion1', true)
    }
    if (path.includes('species/ecoregion2')){
        setExpansionPanel('ecoregion2', true)
    }
}

watch(route, (nv, ov) =>{
    setPanels(nv.fullPath)
})
onMounted(() => {
    // if coming from a route (entered via URL).  expand the correct panel
    setPanels(route.path)
})

</script>
<style >
.rounded{
    border-radius: 3px;
}
 .exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;

 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
</style>